import { CommonModule } from '@angular/common';
import {
  Component,
  DestroyRef,
  inject,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SvgIconGenerationService } from '../../services/svg-icon-generation.service';
import {
  StaticSvgIconProp,
  SvgIcon,
  SvgIconProp,
} from '../../models/dynamic.model';
import { MaterialModule } from '../../material.module';
import { CommonService } from '../../services/common.service';
import { actionText, apiCrudActions, LinkedAccountConstants, pageType } from '../../utility/constants';

@Component({
  selector: 'app-svg-icon',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss'],
})
export class SvgIconComponent {
  private readonly destroyRef = inject(DestroyRef);
  @Input() list!: SvgIconProp[];
  @Input() isStaticSvg!: boolean;
  @Input() iconName!: string;
  @Input() condition!: string;
  @Input() isFrom!: string;

  @Output() iconClicked = new EventEmitter<SvgIcon>();
  @Output() staticIconClicked = new EventEmitter<StaticSvgIconProp>();
  public iconList!: SvgIcon[];
  public staticList!: StaticSvgIconProp;
  public actionText = actionText.miscAccCannotBeDeleted;
  public apInvoiceSendToTooltip = "Cannot send to Customer/GP without a charge";
  public arInvoiceSendToTooltip = actionText.cannotPublishWithoutCharge;

  constructor(
    private readonly svgIconService: SvgIconGenerationService,
    private readonly commonService: CommonService
  ) { }

  ngOnInit() {
    this.commonService.isCheckForMode
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        if (data === 'View') {
          this.iconList = this.svgIconService.generateIconList(this.list);
        } else {
          this.iconList = this.svgIconService.generateIconList(this.list);
        }
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['list']) {
      this.iconList = this.svgIconService.generateIconList(
        changes['list'].currentValue
      );
    } else if (changes['iconName']) {
      this.staticList = this.svgIconService.generateStaticIcon(
        changes['iconName'].currentValue,
        this.isFrom
      );
    }
  }

  public iconClick(icon: any) {
    if (!icon.disabled) {
      this.iconClicked.emit(icon);
    }
  }

  public staticIconClick(staticList: StaticSvgIconProp) {
    this.staticIconClicked.emit(staticList);
  }
  public conditionallyRenderTooltip(icon: SvgIcon) {
    const isRestrictedAccount = !!(icon.isForMiscAccount || icon.isForUFOAccount);
    if (
      this.isFrom === pageType.accountsModule &&
      icon.name === apiCrudActions.delete &&
      icon.disabled &&
      isRestrictedAccount
    ) {
      if (icon.isForMiscAccount && icon.isForUFOAccount) {
        this.actionText = LinkedAccountConstants.bothmiscUfoAccountCannotBeDeleted;
      } else if (icon.isForUFOAccount) {
        this.actionText = actionText.ufoAccCannotBeDeleted;
      } else {
        this.actionText = actionText.miscAccCannotBeDeleted;
      }
      return true;
    }
    return false;
  }

  public conditionallyRenderApInvoiceSendToTooltip(icon: SvgIcon) {
    return (
      this.isFrom === 'ap-invoice' &&
      icon.name === 'sendTo' &&
      icon.disabled
    );
  }

  public conditionallyRenderArInvoiceSendToTooltip(icon: SvgIcon) {
    return (
      (this.isFrom === 'accounts-receivables' || this.isFrom === 'ar-invoice') &&
      icon.name === 'sendTo' &&
      icon.disabled
    );
  }
}
